<template>
  <div class="wrapper">
    <div class="main">
      <page-header/>
      <div class="section">
        <div class="container">
          <div class="col-md-5 mx-auto text-center">
            <h2>訂購完成</h2>
            <p class="font-weight-bold">恭喜您已經完成訂購！</p>
            <img class="my-3" style="width: 80%" src="/img/finish.png" alt="finish image">
            <div>
              <a :href="paymentUrl" v-if="paymentUrl" class="btn btn-danger">申請分唄</a>
              <router-link class="btn btn-info ml-4" :to="{name: 'OrderList'}">檢視訂單列表</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "../partials/PageHeader";

export default {
  name: "OrderFinish",
  components: {
    PageHeader
  },
  computed: {
    paymentUrl() {
      return this.$route.query.payment_url;
    }
  }
}
</script>

<style scoped>

</style>